import './App.css';
import React, { useContext } from "react";
import requests from './base';
import axios from 'axios';
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom"; 
import Login from './Login';
import { UserProvider , UserContext} from './context/UserContext'; // Import UserProvider
import AuthCode from './AuthCode';
import Dashboard from './DashBoard';
import 'bootstrap/dist/css/bootstrap.min.css';
import MainLayout from './MainLayout';
import RegisterVendor from './Register';
import Products from './products';
import Services from './services';
import Orders from './orders';
import 'react-phone-input-2/lib/style.css';
import Vendors from './vendors';
import Commodities from './productsApproval';
import Settings from './settings';
import UserMessages from './messages';
import Admindashboard from './admindashbord';

console.log("Base URL is:", axios.defaults.baseURL);

function App() {
  const { isLogged } = useContext(UserContext);
  return (
    <UserProvider>
    <Routes>
      {/* Public routes without sidebar */}
      <Route path="/login" element={<Login />} />
      <Route path="/RegisterVendor" element={<RegisterVendor />} />
      <Route path="/AuthCode" element={<AuthCode />} />
    

      {/* Protected routes with sidebar */}
      <Route
        path="/"
        element={ ! isLogged ?
          <MainLayout>
            <Dashboard />
            
          </MainLayout>
        : <Navigate to="/login" />}
      />
      <Route
        path="/Admin"
        element={ ! isLogged ?
          <MainLayout>
            <Admindashboard />
            
          </MainLayout>
        : <Navigate to="/login" />}
      />

      <Route
        path="/Products"
        element={ ! isLogged ?
          <MainLayout>
            <Products />
            
          </MainLayout>
        : <Navigate to="/login" />}
      />
       <Route
        path="/services"
        element={ ! isLogged ?
          <MainLayout>
            <Services />
            
          </MainLayout>
        : <Navigate to="/login" />}
      />
      <Route
        path="/settings"
        element={ ! isLogged ?
          <MainLayout>
            <Settings />
            
          </MainLayout>
        : <Navigate to="/login" />}
      />
       <Route
        path="/messages"
        element={ ! isLogged ?
          <MainLayout>
            <UserMessages />
            
          </MainLayout>
        : <Navigate to="/login" />}
      />
        <Route
        path="/Orders"
        element={ ! isLogged ?
          <MainLayout>
            <Orders />
            
          </MainLayout>
        : <Navigate to="/login" />}
      />

<Route
        path="/Vendors"
        element={ ! isLogged ?
          <MainLayout>
            <Vendors />
            
          </MainLayout>
        : <Navigate to="/login" />}
      />
      {/* You can add more routes like below */}
      {/* <Route path="/organizations" element={<MainLayout><Organizations /></MainLayout>} /> */}
      <Route
        path="/Commodities"
        element={ ! isLogged ?
          <MainLayout>
            <Commodities />
            
          </MainLayout>
        : <Navigate to="/login" />}
      />
    </Routes>
    

    
  </UserProvider>

  
  );
}

export default App;
